module.exports = __webpack_public_path__ + "static/img/ticket_bg2.41da9b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ticket_bg2.png
// module id = jbb0
// module chunks = 0